import { render, staticRenderFns } from "./VtTable.vue?vue&type=template&id=040f9971"
import script from "./VtTable.vue?vue&type=script&lang=js"
export * from "./VtTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports